import React from 'react'
import RadioButtonInactive from '../../../../icons/RadioButtonInactive'
import RadioButtonActive from '../../../../icons/RadioButtonActive'
import { $neutralGray100 } from '../../../../../styles/colors/primitives'
import CheckboxChecked from '../../../../icons/CheckboxChecked'
import CheckboxUnchecked from '../../../../icons/CheckboxUnchecked'
import styles from './styles.module.css'

function RadioButtonOrCheckbox({ isSelected, checkboxStyle, checkedColor }) {
  checkedColor = checkedColor || $neutralGray100

  return (
    <>
      {!checkboxStyle && isSelected && <div className={styles.radio} style={{ color: checkedColor }}><RadioButtonActive/></div>}
      {!checkboxStyle && !isSelected && <div className={styles.radio} style={{ color: $neutralGray100 }}><RadioButtonInactive/></div>}
      {checkboxStyle && isSelected && <div className={styles.radio} style={{ color: checkedColor }}><CheckboxChecked/></div>}
      {checkboxStyle && !isSelected && <div className={styles.radio} style={{ color: $neutralGray100 }}><CheckboxUnchecked/></div>}
    </>
  )
}

export default RadioButtonOrCheckbox
